import { render, staticRenderFns } from "./DataEnabledTag.vue?vue&type=template&id=89d3a7b4&scoped=true"
import script from "./DataEnabledTag.vue?vue&type=script&lang=js"
export * from "./DataEnabledTag.vue?vue&type=script&lang=js"
import style0 from "./DataEnabledTag.vue?vue&type=style&index=0&id=89d3a7b4&prod&scoped=true&lang=css"
import style1 from "./DataEnabledTag.vue?vue&type=style&index=1&id=89d3a7b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d3a7b4",
  null
  
)

export default component.exports